import React from 'react'

function Swap() {
  return (
    <div>
        <h1>Swap Page</h1>
    </div>
  )
}

export default Swap